<div *ngIf="loading$|async" class="layout-preloader-container">
  <div class="layout-preloader">
    <span></span>
  </div>
</div>
<router-outlet></router-outlet>
